// @ts-strict-ignore
import React, {
  useContext,
  useMemo,
  useRef,
  useState,
} from 'react';
import {
  AggregationEditorContext,
  AggregationsSubEditorContainer,
} from 'flow/editor/components/aggregations';
import { RuleBuilderContext } from '../../context';
import { ThresholdContext } from './context';
import { useAppDispatch } from '~/store/reduxHooks';
import { resetSubEditor } from 'flow/store/redux/thunks';
import type { AggregationSourceData } from 'flow/editor/components/aggregations/types';
import { INITIAL_AGGREGATION_CONFIG } from 'flow/editor/components/aggregations/constants';

const AggregationsWrapper = () => {
  const dispatch = useAppDispatch();
  const { populatedThreshold } = useContext(ThresholdContext);
  const { keyboardFocus } = useContext(RuleBuilderContext);

  const aggregationEditorContainerRef = useRef<HTMLDivElement>(null);
  const [aggregationContextSourceData, setAggregationContextSourceData] = useState<
  AggregationSourceData
  >(INITIAL_AGGREGATION_CONFIG);

  const aggregationEditorContext = useMemo(() => ({
    sourceData: aggregationContextSourceData,
    setSourceData: setAggregationContextSourceData,
    handleClose: () => {
      dispatch(resetSubEditor());
      keyboardFocus.enable();
    },
    aggregationEditorContainerRef,
  }), [dispatch, keyboardFocus, aggregationContextSourceData, aggregationEditorContainerRef]);

  return (
    <AggregationEditorContext.Provider value={aggregationEditorContext}>
      <AggregationsSubEditorContainer data={{ threshold: populatedThreshold }} />
    </AggregationEditorContext.Provider>
  );
};

export default AggregationsWrapper;
